import {HttpErrorResponse} from '@angular/common/http';

export function isHttpErrorResponse(error: unknown): error is HttpErrorResponse {
  return !!error && (error as HttpErrorResponse).name === 'HttpErrorResponse';
}
